import { buttonStyle } from 'components/buttons/buttonStyle';
import DynamicMultiSelectInput from 'components/forms/inputs/rhf-inputs/DynamicMultiSelectInput';
import { Button } from 'components/ui/button';
import { useForm } from 'react-hook-form';
import { useLazyGetMattersWithFiltersQuery } from 'store/api/matters';
import { MatterListItem } from 'types/matters.ts';
import { t } from 'utils/getTranslations';
import { renderMatterIndicators, renderMatterOptionWithRestrictedSelection } from 'utils/matterOptionRenderer';

interface Props {
    onSubmit: (selectedMatters: MatterListItem[]) => void;
    onClose: () => void;
    defaultValue: MatterListItem[];
}

const ProjectAddMattersModal = ({ onSubmit, onClose, defaultValue }: Props): JSX.Element => {
    const { control, handleSubmit, setValue } = useForm<{ matters: MatterListItem[] }>({
        defaultValues: {
            matters: defaultValue,
        },
    });

    return (
        <form
            onSubmit={(e) => {
                void handleSubmit((data) => {
                    onSubmit(data.matters);
                })(e);
            }}
        >
            <div className="flex min-w-[500px] flex-col gap-6 p-6">
                <p className="text-body1 font-semibold">{t('projects.details-page.header-actions.add-matter')}</p>
                <DynamicMultiSelectInput
                    control={control}
                    name="matters"
                    label="projects.details-page.header-actions.connected-cases"
                    paginated={{
                        fetch: useLazyGetMattersWithFiltersQuery,
                        searchField: ['fullName', 'clientParty.name'],
                        sort: ['clientParty.name,asc', 'name,asc'],
                        filters: 'projectMatters=isEmpty=true',
                    }}
                    groupByField="clientParty.name"
                    getOptionLabel="fullName"
                    getOptionIdentifier="id"
                    getSelectedValueStartAdornment={renderMatterIndicators}
                    customOptionRenderer={(option, props, getValue) =>
                        renderMatterOptionWithRestrictedSelection(option, props, getValue, false)
                    }
                    setValue={setValue}
                />
                <div className="flex justify-end gap-2">
                    <Button {...buttonStyle({ variant: 'outlined' })} onClick={onClose}>
                        {t('cancel')}
                    </Button>
                    <Button type="submit" {...buttonStyle({ variant: 'contained', color: 'secondary' })}>
                        {t('save')}
                    </Button>
                </div>
            </div>
        </form>
    );
};

export default ProjectAddMattersModal;
